import React from "react";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicClosurePropertiesCFL = () => (
  <TOCModuleSubtopic
    title="Closure Properties of CFL"
    videos={[
      "https://www.youtube.com/embed/XEhUMkmVMGs",
    ]}
    takeaways={[
      {
        text: "Learn the proofs of all closure properties and understand how to apply them in different scenarios.",
      },
    ]}
    questions={[]} // Add any relevant questions if needed
    exampleVideos={[]} // Add example question videos if available
  />
);

export { ModuleSubtopicClosurePropertiesCFL };
